import AppDialog from '../../components/app_dialog'
import { Checkbox } from '@cinesend/ui-kit'

const EditModal = ({ validator, fieldTypes, onClose, onChange }) => {
  return (
    <AppDialog title={validator.name} onClose={onClose}>
      <p className='py-2'>{validator.description}</p>
      <p className='py-2'>Fields:</p>
      <ul className='space-y-2 '>
        {fieldTypes.map((field) => {
          const isEnabled =
            validator.field_types.find((ft) => ft.field_type === field && ft.enabled === true) !== undefined

          return (
            <li key={field}>
              <Checkbox text={field} checked={isEnabled} onClick={() => onChange(field, !isEnabled)} />
            </li>
          )
        })}
      </ul>
    </AppDialog>
  )
}

export default EditModal
